import React from 'react';
import LeaseForm from './LeaseForm';
import './GetStarted.css';

function GetStarted() {
  return (
    <section id="get-started" className="get-started">
      <h2>Use our simple form below to get started.</h2>
      <p>Fill out the fields below.</p>
      <div>
        <LeaseForm />
      </div>
    </section>
  );
}

export default GetStarted;